export enum AppraisalType {
  RENT = 'rent',
  SALE = 'sale'
}

export enum LuxuryLevel {
  BASIC = 'BASIC',
  INTERMEDIATE = 'INTERMEDIATE',
  LUXURIOUS = 'LUXURIOUS',
  EXCLUSIVE = 'EXCLUSIVE'
}
export enum WiggotPropertyType {
  HOUSE = 'HOUSE',
  APARTMENT = 'APARTMENT'
}

export enum PreservationState {
  BAD = 'BAD',
  REGULAR = 'REGULAR',
  GOOD = 'GOOD',
  EXCELLENT = 'EXCELLENT'
}

export enum View {
  PANORAMIC = 'panoramic',
  MOUNTAIN = 'mountain',
  CITY = 'city',
  GREEN = 'green',
  SEA = 'sea'
}
